<script>
  // ?id=9921&dnApp=1&dnAppVersion=6.5.5
  // ?id=9921&dnApp=1&dnAppVersion=6.5.5&darkMode=1

  import { onMount } from "svelte";
  import { fade, slide } from "svelte/transition";
  
  import PlayFile from "./components/PlayFile.svelte";
  import PlayLPSVG from "./components/PlayLPSVG.svelte";
  import PlayCoverSpinWithRef from "./components/PlayCoverSpinWithRef.svelte";

  import {
  handleDarkModeSettings,
  darkModeClass,
  marginClass,
  useDarkMode
  } from "../../../../scripts/darkMode";

  import {getUrlParameter} from "../../../../scripts/loadExternalData";
  import { burstPostRatio } from "../../../../scripts/helpers.js";
 
  
  export const state = {
      header: "",
      introduction: "",
      source: "Ljudkälla: Spotify",
      darkModeSettings: 'Följ användarens tema',
      onWeb: false
  };

  import { musiclist } from "./components/static_data";

  const kategoriTillFarg = {
  "Upprepning": "#eb97b5",
  "Självstyrka & Empowerment": "#30aee1",
  "Fred & Enighet": "#98D9E7",
  "Topp party": "#e59840",
  "Topp relaxed": "#78bba3",
  "Hembygd & Nationell stolthet": "#FDD362",
  "Politik & Protest": "#FEC198",
  "Kärlek till musiken & Eurovision-hyllningar": "#FFACCF",
  "Sexualitet & Förförelse": "#EE8288",
  "Hopp & Framtidstro": "#F7A707"
};



const kategoriTillFargOP = {
  "Upprepning": "rgba(235, 151, 181, 0.5)",              // #eb97b5
  "Självstyrka & Empowerment": "rgba(48, 174, 225, 0.5)", // #30aee1
  "Fred & Enighet": "rgba(152, 217, 231, 0.5)",           // #98D9E7
  "Topp party": "rgba(229, 152, 64, 0.5)",                // #e59840
  "Topp relaxed": "rgba(120, 187, 163, 0.5)",             // #78bba3
  "Hembygd & Nationell stolthet": "rgba(253, 211, 98, 0.5)", // #FDD362
  "Politik & Protest": "rgba(254, 193, 152, 0.5)",        // #FEC198
  "Kärlek till musiken & Eurovision-hyllningar": "rgba(255, 172, 207, 0.5)", // #FFACCF
  "Sexualitet & Förförelse": "rgba(238, 130, 136, 0.5)",  // #EE8288
  "Hopp & Framtidstro": "rgba(247, 167, 7, 0.5)"          // #F7A707
};

const kategoriTillBild = {
  "01": "04",
  "02": "05",
  "03": "08",
  "04": "07",
  "05": "06",
  "06": "10",
  "07": "01",
  "08": "02",
  "09": "09",
  "10": "03"
};


let debugstring   = 'debug 1 <br>';
let debug   = false;
let reversed = false;

let isSoundReady = true;
let isPlayingMelody = [];
let isWatingForSound = false;
let PlayFileRef = false;
let PlayLPSVGRef = false;
let fullscreen = false;
let onRealWeb = true;
let hideSoundBar = false;
let showSoundBar = false;
let firstTime = true;


let currentId = 0;


let itemsPerPage = 5;
let currentPage = 1;


let loadedItems = itemsPerPage; // För "Ladda fler"
let usePagination = true; // Styr vilken lista som används


  // Hämta objektets entries och skapa en array av låtar
  let entries = [];


  export let id = 1;
  export let svgpic;
  export let svgSrc;
  export let webPSrc;


let PlayCoverSpinRef = false;
let coverRefs = {}; // { [key:number]: componentInstance }
let currentPlayingId = null;


  $: svgSrc = id != null ? `local_assets/eurovisionCharts/svg/${kategoriTillBild[id.toString().padStart(2, '0')]}.svg` : null;
  $: webPSrc = id != null ? `local_assets/eurovisionCharts/${kategoriTillBild[id.toString().padStart(2, '0')]}.webp` : null;

  // pause klicked
  $: if (!Object.values(isPlayingMelody).some(v => v === true || v === 1 || v === 2)) {

    if (PlayLPSVGRef) {
      const executor = PlayLPSVGRef.isAnimating(false); // Anropa första nivån
      executor(); // Kör den inre funktionen
    }

  }

  $: if (Object.values(isPlayingMelody).some(v => v === 1 || v === 2)) {

    if (PlayLPSVGRef) {
      const executor = PlayLPSVGRef.isAnimating(true); // Anropa första nivån
      executor(); // Kör den inre funktionen
    }
  }


  // paus
$: if (!Object.values(isPlayingMelody).some(v => v === true || v === 1 || v === 2)) {
  if (PlayCoverSpinRef) PlayCoverSpinRef.isAnimating(false)();
}

// play
$: if (Object.values(isPlayingMelody).some(v => v === 1 || v === 2)) {
  if (PlayCoverSpinRef) PlayCoverSpinRef.isAnimating(true)();
}


  $: {

        entries = Object.entries(musiclist);

  }

  // Beräkna total antal sidor
  $: totalPages = Math.ceil(entries.length / itemsPerPage);

  $: paginatedList = usePagination 
    ? entries.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage) 
    : entries.slice(startIndex, startIndex + loadedItems);    

  $: startIndex = usePagination 
    ? (currentPage - 1) * itemsPerPage // Använd `currentPage` som startpunkt
    : startIndex; // Behåll samma startposition när "Ladda fler" används





$: playingId =
  Object.entries(isPlayingMelody).find(([k, v]) => v === true || v === 1 || v === 2)?.[0];

$: {
  // stoppa alla som inte är playingId (om du vill vara safe)
  for (const k in coverRefs) {
    const id = parseInt(k);
    if (String(id) !== String(playingId)) coverRefs[id]?.isAnimating(false)();
  }
  if (playingId) coverRefs[parseInt(playingId)]?.isAnimating(true)();
}








function startSpin(id) {
  coverRefs[id]?.isAnimating(true)();
}

function stopSpin(id) {
  coverRefs[id]?.isAnimating(false)();
}


  // Funktion för att gå till en specifik sida
  function goToPage(page) {
      state.header = paginatedList[0][1]['Kategori'];
      currentPage = Math.min(Math.max(page, 1), totalPages);
      loadedItems = itemsPerPage; // Återställ
      usePagination = true; // Växla till pagination
      burstPostRatio();
  }



  onMount(async() => {
      
      // handle darkmode
      await handleDarkModeSettings(state.darkModeSettings);

      svgpic = useDarkMode();

    

      burstPostRatio();
      

      id = getUrlParameter("id");

      goToPage(id);


}); // on mount




function callPlayMelody(idx) {
  

    if(firstTime){
    burstPostRatio();
    firstTime =false;
    }
    if (PlayFileRef) {
      const executor = PlayFileRef.playMelody(idx); // Anropa första nivån
      executor(); // Kör den inre funktionen
    }



  if (currentPlayingId !== null && currentPlayingId !== idx) {
    stopSpin(currentPlayingId);
  }

  // om id nu spelar:
  startSpin(idx);

  currentPlayingId = idx;

}


function formatPlacering(placering) {
  if (placering === "-") return "";
  
  const nummer = parseInt(placering, 10);
  if (isNaN(nummer)) return "";

  const suffix = (nummer === 1) ? ":a" : ":e";
  return `(${nummer}${suffix})`;
}


function getTitel(melody) {
  return melody.Titel2?.trim() ? melody.Titel2 : melody.Titel;
}



</script>


<main class={`main__content-wrapper style2025 ${$marginClass} ${$darkModeClass}`}>
  <div class="container">
      <div class="container-wrapper">
         {#if paginatedList[0][1]['Kategori'] !== 'Upprepning'}
        <span class="topheader" style={`background-color:${kategoriTillFarg[paginatedList[0][1]['Kategori']]}`}>{paginatedList[0][1]['Kategori']}</span>
        <div class="divider2"></div>
        {/if} 

        <div class="musicList style2025" style={`background-color:${kategoriTillFargOP[paginatedList[0][1]['Kategori']]}`}>
          {#each paginatedList as [key, melody], index (key)}
              <div id="melody-{key}" class="melodyOuther melody-idx-{index+1}" 
                  class:active={parseInt(key) === currentId}>
      
                  <div class="melodyColorBox">
                    
                      <div class="melodyItem">
                          <div class="melodyCoreBox"> 
                            <div class="box4wrapper">
                              {#if paginatedList[0][1]['Kategori'] !== 'Upprepning'}
                              <div class="number-wrapper" style={`background-color:${kategoriTillFarg[paginatedList[0][1]['Kategori']]}`}>{index+1}</div>
                              {/if} 
                              <div class="circle-wrapper">
                             
                              <PlayCoverSpinWithRef
                                id={parseInt(key)}
                                {coverRefs}
                                imgSrc={`local_assets/melloCharts/songssvg/${key}.svg`}
                                size="100%"
                              />

                              </div>  
                            </div>                      
                            <div class="box2wrapper">
                                  <div class="secondItem">{melody.Artist} - {melody.Year}</div>
                                  <div class="smalltextdivider"></div>
                                  <div class="thirdItem">{getTitel(melody)} </div>  
                            </div>
                            <div class="box3wrapper">
                                  <div class="thirdItem">{melody.Kategori}</div>
                                  <div class="thirdItem fourthItem">{melody.ID}</div>
                            </div>
                            <div class="box5wrapper">
                                {#if musiclist[key].preview_url !== null && musiclist[key].preview_url !== ''}
                                <div class="mellodyButtons" 
                                class:isPlaying={isPlayingMelody[parseInt(key)] === true || isPlayingMelody[parseInt(key)] === 1 || isPlayingMelody[parseInt(key)] === 2 } 
                                class:waiting={isWatingForSound === parseInt(key)}>
                                  <div class:showplayer={isSoundReady}  class="mellodyPlayButton" on:click={() => callPlayMelody(parseInt(key))} on:keydown={() => callPlayMelody(parseInt(key))} >
                                    <div class="smalldivider"></div>
                                    <div class="buttonPlay"><div class="play-button-black" style={`background-color:${kategoriTillFarg[paginatedList[0][1]['Kategori']]}`}></div></div>
                                    <div class="buttonPause"><div class="pause-button-black" style={`background-color:${kategoriTillFarg[paginatedList[0][1]['Kategori']]}`}><div></div><div></div></div></div>
                                  </div> 
                                </div> 
                                {/if} 
                            </div>

                          </div>
                      </div> 
                  </div>
              </div>
          {/each}

          

      </div>
      <PlayFile
      bind:this={PlayFileRef}
      bind:isSoundReady={isSoundReady}
      bind:isPlayingMelody={isPlayingMelody}
      bind:isWatingForSound={isWatingForSound}
      bind:showSoundBar
      fullscreen={fullscreen}
      onRealWeb={onRealWeb}
      musiclist={musiclist}
      hideSoundBar={hideSoundBar}
       /> 






      </div> 

  {#if state.source}
  <div class="standard-source">
    {@html state.source}
  </div>
  <br>
  {/if}
  </div> 

</main>
<div class="debugger">{@html debugstring}</div>


<style global type="text/scss" lang="scss">
/* ==========================================================================
   EUROVISION / MELLO LIST UI (style2025)
   Steg 1: Städa upp syntax, gruppera, kommentera.
   - Inga namnbyten
   - Inga beteendeförändringar (så långt det går)
   - Tar bort dubbla/trasiga regler endast när de är uppenbart fel
   ========================================================================== */

/* ==========================================================================
   CSS Variables / Theme tokens
   ========================================================================== */

:root {
  /* Text colors */
  --text-color-melody: #ededed;
  --text-color-artist: #ededed;
  --text-color-album: #45666a;
  --text-color-date: #45666a;
  --text-color-dina-val: #ccc;
  --text-color-not-selected: #36545d;

  /* Type scales */
  --list-text-size-large: 2.1rem;
  --list-text-size-medium: 1.8rem;
  --list-text-size-small: 1.4rem;

  /* Base backgrounds */
  --bg-color-site: #345966;
  --bg-color-melody: #163b48;
  --bg-color-melody-selected: #0c2831;

  /* Misc */
  --melody--nr2-color: #ffeb00;
  --melody--nr1-colorXXX: #f69d00; /* legacy */
  --melody--nr1-color: #345966;

  --bg-color-play: #345966;
  --bg-color-vote: #345966;

  --mellody-height: 7.4rem;
  --button-height: 9rem;

  --selected-color: #ffeb00;
}

/* Theme override used on wrapper */
.style2025 {
  /* Text */
  --text-color-header: #fff;
  --text-color-vote-box: #ededed;
  --text-color-sound-box: #ededed;

  --text-color-melody: #333;
  --text-color-artist: #141414;
  --text-color-artist-dark:#b7b7b7;
  --text-color-album: #141414;
  --text-color-date: #141414;

  /* BG */
  --bg-color-vote-box: #345966;
  --bg-color-site: #f0f0f0;
  --bg-color-list: #909090;
  --bg-color-list-dark: #1f1f1f;

  --bg-color-melody: #ffffff;
  --bg-color-melody-dark: #141414;

  --bg-color-melody-selected: #ccc;
  --bg-color-melody-selected-dark: #4a4a4a;

  --bg-color-play: #000;
  --bg-color-pause: #000;
  --bg-color-play-white: #fff;
  --bg-color-pause-white: #fff;

  --bg-color-vote: #da000d;
  --bg-color-sound-box: #f8f8f8;

  /* Layout */
  --mellody-height: 12rem;
  --mellody-button-height: 6rem;
  --button-height: 9rem;

  --text-color-melody-button: #ededed;

  --box-padding-melody: 0rem;

  /* Type scale */
  --list-text-size-large: 3.8rem;
  --list-text-size-large2: 4.2rem;
  --list-text-size-medium: 1.6rem;
  --list-text-size-small: 1.6rem;

  --list-text-weight-large: 600;
  --list-text-weight-medium: 500;
  --list-text-weight-small: 300;

  /* Spacing */
  --divider-small: 0rem;
  --divider-medium: 2rem;
}

/* ==========================================================================
   Debug
   ========================================================================== */

.debugger {
  font-size: 9px;
  line-height: 1;
  display: none;
}

/* ==========================================================================
   Base / page wrapper
   ========================================================================== */

body {
  margin: 0;
  padding: 0;
  line-height: 1.4;

  font-family: DNSansVF, Georgia, "Times New Roman", Times, serif;
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;

  overflow: unset;
}

main {
  position: relative;
  width: 100%;

  margin: 0 auto;
  margin-left: auto;
  margin-right: auto;

  max-width: 600px;
  box-sizing: border-box;

  background-color: transparent;
  transition: all 0.9s ease-in-out;
}

/* Layout containers */
.container {
  position: relative;
  width: 100%;
}



.container-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

/* Main wrapper padding (DN wrapper class) */
.main__content-wrapper {
  padding-top: 0;
  padding-bottom: 0;
}

/* ==========================================================================
   List container
   ========================================================================== */

.musicList {
  position: relative;
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;

  margin-bottom: 0;

  background-color: var(--bg-color-list);
}

.main__dark-mode .musicList {
  background-color: #484848;
}

/* Collapse mode: hides rows/buttons */
.musicList.collapse {
  margin-bottom: 0;

  .mellodyButtons {
    height: 0;
    padding: 0;
    margin: 0;
    overflow: hidden;
  }

  .melodyColorBox {
    border: 0 solid #000;
    height: 0;
    padding: 0;
    margin: 0;
    overflow: hidden;
  }

  .melodyItem {
    height: 0;
    padding: 0;
    margin: 0;
  }
}

/* Optional top line */
.firstline {
  width: 100%;
  height: 1px;
  background-color: var(--bg-color-list);

  &.off {
    display: none;
  }
}

/* ==========================================================================
   Row wrappers
   ========================================================================== */

.melodyOuther {
  position: relative;
  width: 100%;

  margin: 0;
  padding: 0;
  padding-left: 0;
  padding-right: 0;

  box-sizing: border-box;

  background-color: transparent;
  transition: all 0.9s ease-in-out;

  z-index: 0;

  /* Visually mark empty placeholder rows */
  &.empty {
    opacity: 0.5;
  }

  &.active .melodyColorBox {
    background-color: var(--bg-color-melody-selected);
  }

  &.active .melodyCoreBox {
    padding-top: 0;
  }

  &.active .box3 {
    display: none;
  }
}

.onRealWeb .melodyOuther {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.main__dark-mode .melodyOuther.active .melodyColorBox {
  background-color: var(--bg-color-melody-selected-dark);
}

/* The colored row background */
.melodyColorBox {
  position: relative;
  width: 100%;

  margin: 0;
  padding: 0;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: flex-start;
  align-items: flex-start;

  box-sizing: border-box;

  margin-bottom: 1px;

  border-radius: 0;
  border: 0 solid transparent;

  padding-left: var(--box-padding-melody);
  padding-right: 0rem;
  padding-top: var(--box-padding-melody);
  padding-bottom: var(--box-padding-melody);

  min-height: 8rem;

  background-color: var(--bg-color-melody);
}

.main__dark-mode .melodyColorBox {
  background-color: var(--bg-color-melody-dark);
}

/* Core row layout */
.melodyItem {
  position: relative;
  width: 100%;

  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: center;
  align-items: center;

  height: var(--mellody-height);

  padding: 0;
  box-sizing: border-box;

  background-color: transparent;

  color: var(--text-color-melody);
  transition: all 0.3s ease-in-out;

  overflow: hidden;
  cursor: pointer;
}

/* The flex row inside the item */
.melodyCoreBox {
  position: relative;
  width: 100%;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  align-items: center;

  z-index: 2;

  margin-top: 0;
  padding-top: 0;
  padding-left: 0;

  box-sizing: border-box;
}



/* ==========================================================================
   Column boxes (layout)
   ========================================================================== */

.box1 {
  position: relative;
  width: 100%;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  align-items: center;

  z-index: 2;

  margin-top: 0;
  padding-top: 0;

  padding-left: 0;
  box-sizing: border-box;
}

.box1wrapper {
  position: relative;
  width: 18%;

  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-content: flex-start;
  align-items: flex-start;
}

.box2wrapper {
  position: relative;
  width: 60%;

  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-content: flex-start;
  align-items: flex-start;
}

.box3wrapper {
  position: relative;
  width: 20%;

  display: none;

  flex-direction: column;
  justify-content: space-evenly;
  align-content: flex-start;
  align-items: flex-start;
}

.box4wrapper {
  position: relative;
  width: 20%;
  height: auto;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
}

.box5wrapper {
  position: relative;
  width: 10%;

  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-content: flex-start;
  align-items: flex-start;
}


.number-wrapper {

  position: absolute;
  top: 1.2rem;
  left: 0.4rem;
  width: 2.5rem;
  height: 2.5rem;
  font-size: 1.5rem;
  color: #fff;
  border-radius: 100%;
  background-color: red;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  font-weight: 800;

}

/* Circle image wrapper */
.circle-wrapper {
  aspect-ratio: 1;
  width: 100%;
  max-width: 100px;

  border-radius: 50%;
  overflow: hidden;

  display: flex;
  justify-content: center;
  align-items: center;

  border: 1px solid #e4e4e4;
}

.main__dark-mode .circle-wrapper {
  border: 1px solid #464646;
}

.circle-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}





/* ==========================================================================
   Typography (list items)
   NOTE: There are duplicates later in original CSS; here we keep ONE set.
   ========================================================================== */

.firstItem {
  font-family: DNSansVF, Georgia, "Times New Roman", Times, serif;
  font-size: var(--list-text-size-large);
  font-variation-settings: "opsz" 18;

  color: var(--text-color-melody);
  line-height: 1.1;
  font-weight: 900;

  font-feature-settings: "tnum";

  /* NOTE: original had -webkit-text-strokex (typo). Left out intentionally. */
}

.secondItem {
  font-family: DNSansVF, Times, "Times New Roman", serif;
  font-size: var(--list-text-size-medium);

  color: var(--text-color-artist);
  line-height: 1.1;

  font-weight: var(--list-text-weight-large);
}

.thirdItem {
  font-family: DNSansVF, Georgia, "Times New Roman", Times, serif;
  font-size: var(--list-text-size-small);

  color: var(--text-color-album);
  line-height: 1.1;

  /* NOTE: original had "font-weight: var (--list-text-size-small)" (syntax bug) */
  font-weight: var(--list-text-weight-small);

  .date {
    color: var(--text-color-date);
  }
}

/* Dark mode overrides (original references a missing var --text-color-artist-dark) */
.main__dark-mode {
  .secondItem,
  .thirdItem {
    /* kept as-is but safer fallback */
    color: var( --text-color-artist-dark, #ededed);
  }
}

@media screen and (min-width: 519px) {
  .firstItem {
    font-size: var(--list-text-size-large2);
  }
}

/* ==========================================================================
   Buttons (play/pause) for each row
   ========================================================================== */

.mellodyButtons {
  position: relative;
  width: 100%;

  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-content: center;
  align-items: center;

  gap: 2rem;

  margin: 0;
  margin-top: 0;
  margin-bottom: 1px;
  padding: 0;
  padding-left: 0rem;

  height: unset;
  box-sizing: border-box;

  background-color: transparent;

  /* Toggle play/pause icons */
  &.isPlaying {
    .buttonPlay {
      display: none;
    }
    .buttonPause {
      display: flex;
    }
  }

  /* Hover/active state (only if `.active` exists on mellodyButtons) */
  &.active:active,
  &.active:hover {
    background-color: #76b2e9;
  }
}

.mellodyPlayButton {
  display: none;
  cursor: pointer;

  flex-direction: row;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;

  &.showplayer {
    display: flex;
  }
}

/* Spacers */
.verticaldivider {
  position: relative;
  width: 2rem;
}

.smalldivider {
  width: var(--divider-small);
}

.mediumdivider {
  width: var(--divider-medium);
}

.smalltextdivider {
  height: 0.5rem;
}

.divider {
  height: 1rem;
}
.divider2 {
  height: 2rem;
}

/* Typography scaling helpers in buttons */
.buttonPlay {
  font-size: 1.2rem;
}

.buttonPause {
  font-size: 1.2rem;
  display: none;
}

.soundColorBox {
  .buttonPlay {
    font-size: 0.7rem;
  }

  .buttonPause {
    font-size: 0.7rem;
    display: none;
  }
}

/* ==========================================================================
   Play button variants
   ========================================================================== */

/* Legacy wrappers kept */
.buttonPlayX {
  width: 3rem;
  height: 3rem;

  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;

  background-color: var(--bg-color-play);
  border-radius: 50%;
}

/* NOTE: .play-button exists but isn't used in markup shown. Kept anyway. */
.play-button,
.play-button-black {
  position: relative;
  width: 4.5em;
  height: 4.5em;

  background-color: var(--bg-color-play);
  border-radius: 50%;

  display: flex;
  justify-content: center;
  align-items: center;
}

/* Triangle for both */
.play-button::after,
.play-button-black::after {
  content: "";
  position: absolute;

  width: 0;
  height: 0;

  border-style: solid;
  border-width: 1.00em 0 1.00em 1.5em;
  border-color: transparent transparent transparent white;

  transform: translateX(0.3125em);
}

/* Small white play button (used in your markup inside PlayFile too) */
.play-button-white {
  position: relative;
  width: 4em;
  height: 4em;

  background-color: var(--bg-color-play-white);
  border-radius: 50%;

  display: flex;
  justify-content: center;
  align-items: center;

  box-shadow: 0 0.01em 0.4em rgba(0, 0, 0, 0.2);

  &::after {
    content: "";
    position: absolute;

    width: 0;
    height: 0;

    border-style: solid;
    border-width: 1.25em 0 1.25em 2.08em;
    border-color: transparent transparent transparent #333;

    transform: translateX(0.3125em);

    /* Original: font-size used as scaling trick */
    font-size: 0.43rem;
  }
}

/* Waiting state changes triangle color/size */
.mellodyButtons.waiting .buttonPlay .play-button-white::after {
  border-color: transparent transparent transparent #dcd9d9;
  transform: translateX(0.3125em);
  font-size: 0.33rem;
}

@media screen and (min-width: 519px) {
  .play-button-white {
    width: 6em;
    height: 6em;
    font-size: 0.53rem;
  }
}

/* ==========================================================================
   Pause button variants
   ========================================================================== */

.buttonPauseX {
  width: 3rem;
  height: 3rem;

  display: none;

  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;

  background-color: var(--bg-color-pause);
  border: 0 solid var(--bg-color-play);
  border-radius: 50%;
}

/* Generic pause button (kept) */
.pause-button,
.pause-button-black {
  position: relative;
  width: 5em;
  height: 5em;

  background-color: #000;
  border-radius: 50%;

  display: flex;
  justify-content: center;
  align-items: center;

  &::after {
    content: "";
    position: absolute;
    display: flex;
    gap: 0.4em;
  }

  div {
    width: 0.5em;
    height: 2.5em;

    background-color: white;
    border-radius: 0.1em;
  }

  div:first-of-type {
    margin-right: 0.2rem;
  }

  div:last-of-type {
    margin-left: 0.2rem;
  }
}


/* ==========================================================================
   Header
   ========================================================================== */

.topheader {
  position: relative;
  width: 70%;

  font-size: 4rem;
  padding: 1rem;

  color: var(--text-color-header);
  font-weight: 700;

}

/* ==========================================================================
   Responsive base font sizing (kept as in original)
   ========================================================================== */

@media only screen and (min-width: 420px) {
  html,
  body {
    font-size: 2.1vw;
  }
}

@media only screen and (min-width: 519px) {
  html,
  body {
    font-size: 10px;
  }
}

</style>